<template>
  <div class="result-box">
    <div v-if="statusCode == 1" class="img-box">
      <img
        class="result-img"
        src="@/assets/img/mobile-img/sign-pending.png"
        alt=""
      />
      <p class="result-tip">提交成功，等待平台审核</p>
      <p class="result-text">预计1-3个工作日完成,审核结果将通过短信通知您</p>
    </div>
    <div v-if="statusCode == 2" class="img-box">
      <img
        class="result-img"
        src="@/assets/img/mobile-img/sign-success.png"
        alt=""
      />
      <p class="result-tip">开通成功</p>
      <p class="result-text">
        已为您开启知识合伙人{{
          $route.query.title
        }}相关权益，您可登录中文知识网PC端管理您的网站内容
      </p>
    </div>
    <div v-if="statusCode == 3" class="img-box">
      <img
        class="result-img"
        src="@/assets/img/mobile-img/sign-fail.png"
        alt=""
      />
      <p class="result-tip">审核失败</p>
      <p class="result-text">
        抱歉，您提交的知识合伙人{{
          $route.query.title
        }}相关权益申请未通过平台审核，请依据审核意见修改后再次提交
      </p>
    </div>
    <div v-if="statusCode == 4" class="img-box">
      <img
        class="result-img"
        src="@/assets/img/mobile-img/sign-fail.png"
        alt=""
      />
      <p class="result-text">您的{{ $route.query.title }}权益已关闭</p>
    </div>
    <div
      class="content-box"
      v-if="!((statusCode == 3 && resultObj.reason === '') || statusCode == 4)"
    >
      <p v-if="statusCode == 3" class="content-reason">
        {{ resultObj.reason }}
      </p>
      <div v-if="statusCode == 1 || statusCode == 2">
        <p class="content-title">{{ role }}官网信息：</p>
        <div class="content-text">
          <div class="content-text-label">网站名称：</div>
          <div class="content-text-value">{{ resultObj.webSiteName }}</div>
        </div>
        <div class="content-text">
          <span class="content-text-label">站点网址：</span>
          <span class="content-text-value">{{ resultObj.webAddress }}</span>
        </div>
        <div class="content-text" v-if="resultObj.recordNumber">
          <span class="content-text-label">备案号：</span>
          <span class="content-text-value">{{ resultObj.recordNumber }}</span>
        </div>
      </div>
    </div>
    <div class="result-btn">
      <van-button
        v-if="statusCode == 3"
        color="#4a79f1"
        round
        type="info"
        @click="toReapply"
        >重新申请</van-button
      >
      <van-button
        v-else
        color="#4a79f1"
        plain
        round
        hairline
        @click="() => this.$router.push({name:'home'})"
        >返回首页</van-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "EquityResult",
  data() {
    return {
      resultObj: {},
      statusCode: null,
    };
  },
  created() {
    this.getPartnerDetail();
  },
  computed: {
    role() {
      let userInfo = sessionStorage.getItem("userInfo");
      if (userInfo) {
        let type = JSON.parse(userInfo).user.customerType;
        return type === 4 ? "期刊" : type === 5 ? "机构" : "";
      } else {
        return "";
      }
    },
  },
  methods: {
    async getPartnerDetail() {
      const res = await this.$apis.userServe.getPartnerDetail();
      if (res.resultCode === "200") {
        const businessList = res.content.businessList;
        const info = businessList.find((item) => item.roleId === "16");
        this.resultObj = JSON.parse(info.extraInfo);
        if (info.reason) this.resultObj.reason = info.reason;
        this.statusCode = info.statusCode;
      }
    },
    toReapply() {
      this.$router.replace({
        path: "/partner/partner-equity-website",
        query: this.$route.query,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.result-box {
  padding: 0 12px;
  .img-box {
    margin-top: 10vh;
    text-align: center;
    .result-img {
      width: 96px;
      height: 92px;
    }
    .result-tip {
      margin: 8px 0 11px;
      font-size: 15px;
      color: #333333;
    }
    .result-text {
      font-size: 13px;
      color: #999999;
    }
  }
  .content-box {
    margin-top: 25px;
    padding: 15px 17px;
    width: 100%;
    background-color: #f5f5f5;
    border-radius: 8px;
    .content-title {
      font-size: 13px;
      color: #999999;
    }
    .content-reason {
      font-size: 13px;
      color: #333333;
    }
    .content-text {
      margin-top: 12px;
      font-size: 13px;
      color: #333333;
      display: flex;
      .content-text-label {
        width: 70px;
      }
      .content-text-value {
        flex: 1;
      }
    }
    .flex-content {
      display: flex;
      .flex-label {
        flex: none;
        width: 105px;
      }
    }
  }
  .result-btn {
    margin-top: 30px;
    text-align: center;
    &::v-deep .van-button {
      width: 117px;
    }
  }
}
</style>
